
import { useState } from 'react';

interface Pet {
  id: number;
  name: string;
  category: string;
  breed: string;
  age: string;
  gender: string;
  price: number;
  location: string;
  description: string;
  image: string;
  seller: string;
  featured: boolean;
}

interface PetCardProps {
  pet: Pet;
  onViewDetails: (pet: Pet) => void;
}

export default function PetCard({ pet, onViewDetails }: PetCardProps) {
  const [liked, setLiked] = useState(false);

  return (
    <article
      className="bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer group relative"
      onClick={() => onViewDetails(pet)}
    >
      {pet.featured && (
        <div className="absolute top-4 left-4 z-10 bg-gradient-to-r from-[#F5A623] to-[#FF9BC8] text-white text-xs font-bold px-3 py-1 rounded-full shadow-md">
          <i className="ri-star-fill mr-1"></i>Featured
        </div>
      )}

      <button
        onClick={(e) => {
          e.stopPropagation();
          setLiked(!liked);
        }}
        className="absolute top-4 right-4 z-10 w-9 h-9 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-md hover:scale-110 transition-all cursor-pointer"
      >
        <i className={`${liked ? 'ri-heart-fill text-red-500' : 'ri-heart-line text-[#8B7BA8]'} text-lg`}></i>
      </button>

      <div className="w-full h-56 overflow-hidden relative">
        <img
          src={pet.image}
          alt={`${pet.name} - ${pet.breed}`}
          className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black/20 to-transparent"></div>
      </div>

      <div className="p-5">
        <div className="mb-2">
          <h3 className="text-lg font-bold text-[#4A3B5C]" style={{ fontFamily: 'Poppins, sans-serif' }}>
            {pet.name}
          </h3>
        </div>

        <p className="text-sm text-[#8B7BA8] font-medium mb-3">{pet.breed}</p>

        <div className="flex items-center gap-4 text-xs text-[#8B7BA8] mb-3">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line w-4 h-4 flex items-center justify-center"></i>
            {pet.age}
          </span>
          <span className="flex items-center gap-1">
            <i className={`${pet.gender === 'Male' ? 'ri-men-line' : 'ri-women-line'} w-4 h-4 flex items-center justify-center`}></i>
            {pet.gender}
          </span>
        </div>

        <div className="flex items-center justify-between pt-3 border-t border-[#F0EBF8]">
          <span className="flex items-center gap-1 text-xs text-[#8B7BA8]">
            <i className="ri-map-pin-line w-4 h-4 flex items-center justify-center"></i>
            {pet.location}
          </span>
          <span className="text-xs font-semibold text-[#9B4C9A] group-hover:underline">
            View Details &rarr;
          </span>
        </div>
      </div>
    </article>
  );
}
